import React from 'react';
import type { BonusConfig, RarityDetail } from '@/hooks/useBonusMultiplier';

interface Props {
  rarityDetails: RarityDetail[];
  baseRoyaltyPercentage: number;
  adjustedRoyaltyPercentage: number;
  bonusConfig?: BonusConfig | undefined;
}

const BonusMultiplierBreakdown = ({
  rarityDetails,
  baseRoyaltyPercentage,
  adjustedRoyaltyPercentage,
  bonusConfig,
}: Props) => {
  if (rarityDetails.length === 0 || !bonusConfig) return null;

  const rarityColorClass = (rarity: string, bonusConfig: BonusConfig) => {
    const color = bonusConfig.rarityConfigs[rarity]?.color || 'gray';
    return `bg-${color}-500`;
  };

  const renderTableRow = (detail: RarityDetail, index: number) => (
    <tr key={index}>
      <td className="py-0.5 text-right">
        <span
          className={`inline-flex items-center justify-center rounded-lg px-2 py-1 text-white ${rarityColorClass(
            detail.rarity,
            bonusConfig
          )}`}
        >
          {detail.rarity}
        </span>
      </td>
      <td className="text-center">{detail.count}</td>
      <td className="text-left">{detail.bonusPercentage}%</td>
    </tr>
  );

  return (
    <table>
      <thead>
        <tr>
          <th className="pb-1 pt-1.5 text-right">Rarity</th>
          <th className="px-2 pb-1 pt-1.5 text-center">#</th>
          <th className="pb-1 pt-1.5 text-left">Bonus</th>
        </tr>
      </thead>
      <tbody>
        {rarityDetails
          .filter((detail) => detail.rarity !== 'Unknown')
          .map(renderTableRow)}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={2} className="pr-2 pt-3 text-right">
            Base Royalty
          </td>
          <td className="pt-3 text-left">{baseRoyaltyPercentage}%</td>
        </tr>
        <tr>
          <td colSpan={2} className="pb-2 pl-4 pr-2 text-right font-bold">
            Adjusted Royalty
          </td>
          <td className="pb-2 pr-4 text-left font-bold">
            {adjustedRoyaltyPercentage}%
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default BonusMultiplierBreakdown;
